// Parent component what coordinates what execution contents (errors/success) to show
import React from "react";
import { useSelector } from "react-redux";
import mapCodesToMessages from "../../../utils/merge/map-codes-to-messages";
import {
  getMergeExecuteError,
  getMergeExecuteErrors,
  getMergeExecuteLoading,
  getSourceUsername
} from "../../../store/merge";
import Loading from "../../loading";
import MergeError from "../error";
import ExecutionSuccess from "./success";

const Execution = () => {
  const executionErrors = useSelector(getMergeExecuteErrors) || [];
  const executionError = useSelector(getMergeExecuteError);
  const loading = useSelector(getMergeExecuteLoading);
  const username = useSelector(getSourceUsername);
  const errorMessageDescriptors = mapCodesToMessages(executionErrors);

  /**
   * Some error codes may not have a mapped message.
   * The error component should be displayed even if none of the error codes map to a message.
   */
  if (Boolean(executionError) || executionErrors.length > 0) {
    return <MergeError {...{ errorMessageDescriptors, username }} />;
  } else if (loading) {
    return <Loading />;
  } else {
    return <ExecutionSuccess />;
  }
};

export default Execution;
